import React, { useLayoutEffect } from 'react';
import { connect } from "react-redux";
import { clearSecurityProfiles, getSecurityProfiles } from "../../../../actions/security/SecurityProfile";
import { NEW_SECURITY_PROFILE_PATH, SECURITY_PROFILE_PATH } from "../../../../config/paths";
import PropTypes from "prop-types";
import { breadcrumbsPropTypes } from "../../../common/resource/proptypes/CommonPropTypes";
import Immutable from "immutable";
import { DEFAULT_PAGE_SIZE } from "../../../../config/constants";
import { SECURITY_PROFILES_COLUMNS } from "../../../../config/columns";
import ModuleList from "../../../layout/ModuleList";


const SecurityProfiles = ({
  breadcrumbs,
  securityProfiles,
  loading,
  dispatchGetSecurityProfiles,
  dispatchClearSecurityProfiles,
}) => {
    useLayoutEffect(() => () => dispatchClearSecurityProfiles(), []);

    const data = securityProfiles.get('content') || [];
    const pages = securityProfiles.get('totalPages') || null;
    const defaultPageSize = securityProfiles.get('size') || DEFAULT_PAGE_SIZE;
  
    return (
      <ModuleList
        title="Lista de Perfiles de Seguridad"
        breadcrumbs={breadcrumbs}
        buttonPath={NEW_SECURITY_PROFILE_PATH}
        tableStructure={{
          columns: SECURITY_PROFILES_COLUMNS,
          data,
          pages,
          defaultPageSize,
          filterable: true,
          fetchData: dispatchGetSecurityProfiles,
          modelPath: SECURITY_PROFILE_PATH,
          loading,
          navigateToModelOnRowClick: true,
        }}
      />
    );
};

SecurityProfiles.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchClearSecurityProfiles: PropTypes.func.isRequired,
  dispatchGetSecurityProfiles: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  securityProfiles: PropTypes.instanceOf(Immutable.Map),
};

SecurityProfiles.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearSecurityProfiles: clearSecurityProfiles,
  dispatchGetSecurityProfiles: getSecurityProfiles,
};

const mapStateToProps = ({ SecurityUnit }) => ({
  breadcrumbs: [
    ...SecurityUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Perfiles de Seguridad',
      href: SECURITY_PROFILE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  securityProfiles: SecurityUnit.SecurityProfile.getIn(['all', 'content']),
  loading: SecurityUnit.SecurityProfile.getIn(['all', 'loading']),
});

SecurityProfiles.defaultProps = {
  securityProfiles: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(SecurityProfiles);